<template>
    <div class="text-xs text-foreground/80">
        <label class="flex items-start gap-2 select-none">
            <input type="checkbox" required class="mt-0.5 accent-current" />
            <span>
                Я даю
                <a href="#" class="text-accent hover:underline" @click.prevent="open = true">
                    согласие на обработку персональных данных
                </a>
            </span>
        </label>

        <Teleport to="body">
            <div
                v-if="open"
                class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
                @click.self="open = false"
            >
                <div
                    class="flex max-h-[85vh] w-full max-w-2xl flex-col rounded-2xl border border-border bg-card shadow-lg"
                    role="dialog"
                    aria-modal="true"
                    aria-label="Согласие на обработку персональных данных"
                >
                    <div class="overflow-y-auto whitespace-pre-line p-6 text-sm text-foreground">{{ text }}</div>
                    <div class="flex justify-end border-t border-border p-4">
                        <button
                            type="button"
                            class="rounded-md bg-accent px-6 py-2.5 font-semibold text-accent-foreground transition-colors hover:bg-accent/90"
                            @click="open = false"
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
// Сервер согласие не проверяет, required у чекбокса — единственная преграда:
// docs/domains/readme.md, «Согласие на обработку ПД».
export default {
    name: "ConsentCheckbox",
    props: {
        // полный текст из настроек домена; выводится как текст, без разметки
        text: { type: String, required: true },
    },
    data() {
        return { open: false };
    },
    watch: {
        open(value) {
            if (value) {
                window.addEventListener("keydown", this.closeOnEscape);
            } else {
                window.removeEventListener("keydown", this.closeOnEscape);
            }
        },
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.closeOnEscape);
    },
    methods: {
        closeOnEscape(event) {
            if (event.key === "Escape") {
                this.open = false;
            }
        },
    },
};
</script>
